import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { hasGamesStarted, isFixtureOpened } from 'lib/so5';

import { LineupRankingDumb } from './Dumb';
import type { LineupRanking_so5LeaderboardContender } from './__generated__/index.graphql';

type Props = {
  so5LeaderboardContender?: LineupRanking_so5LeaderboardContender;
  onClick?: () => void;
};

export const LineupRanking = ({ so5LeaderboardContender, onClick }: Props) => {
  const { so5Leaderboard, so5Lineup } = so5LeaderboardContender || {};
  const isUpcoming =
    so5Leaderboard && isFixtureOpened(so5Leaderboard.so5Fixture);

  if (isUpcoming || !so5Lineup) {
    return null;
  }

  const ranking = so5Lineup.so5Rankings.at(0);
  const hasLineupGamesStarted = hasGamesStarted(so5Lineup);
  const showRankingAndScore = ranking && hasLineupGamesStarted;

  return (
    <LineupRankingDumb
      showRankingAndScore={showRankingAndScore}
      ranking={ranking}
      score={ranking?.score}
      onClick={onClick}
    />
  );
};

LineupRanking.fragments = {
  so5LeaderboardContender: gql`
    fragment LineupRanking_so5LeaderboardContender on So5LeaderboardContender {
      slug
      so5Leaderboard {
        slug
        so5Fixture {
          slug
          ...isFixtureOpened_so5Fixture
        }
      }
      so5Lineup {
        id
        so5Rankings {
          id
          ranking
          rankingRatio(top: true)
          score
        }
        ...hasGamesStarted_so5Lineup
      }
    }
    ${isFixtureOpened.fragments.so5Fixture}
    ${hasGamesStarted.fragments.so5Lineup}
  ` as TypedDocumentNode<LineupRanking_so5LeaderboardContender>,
};
